import type { LinkRelationshipTypeOption, NullableOption } from './types.tsx';

const INWARD_DIRECTION = 'inwards';
const OUTWARD_DIRECTION = 'outwards';

export const capitalize = (str: string) => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};

export const createOptionsFromIssueLinkTypeData = (node: {
	id: string;
	inwards: string;
	outwards: string;
}): LinkRelationshipTypeOption[] => {
	const options: LinkRelationshipTypeOption[] = [];
	if (!node || !node.inwards || !node.outwards || !node.id) return options;

	const isSymmetricRelation = node.inwards === node.outwards;
	if (isSymmetricRelation) {
		options.push({
			value: node.id,
			label: capitalize(node.outwards),
			id: `${node.id}_${OUTWARD_DIRECTION}`,
			direction: OUTWARD_DIRECTION,
		});
	} else {
		options.push({
			value: node.id,
			label: capitalize(node.outwards),
			id: `${node.id}_${OUTWARD_DIRECTION}`,
			direction: OUTWARD_DIRECTION,
		});

		options.push({
			value: node.id,
			label: capitalize(node.inwards),
			id: `${node.id}_${INWARD_DIRECTION}`,
			direction: INWARD_DIRECTION,
		});
	}

	return options;
};

export const createSelectedOptionFromFieldData = (issueLinkData: {
	issueLinkTypeARI: string;
	relationName: string;
	direction: string;
}): NullableOption => {
	const { issueLinkTypeARI, relationName, direction } = issueLinkData || {};

	if (!issueLinkTypeARI || !relationName || !direction) return null;

	return {
		id: `${issueLinkTypeARI}_${direction}`,
		value: issueLinkTypeARI,
		label: capitalize(relationName),
		direction,
	};
};
